
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategy/rs4_us",
      function () {
        return require("private-next-pages/strategy/rs4_us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategy/rs4_us"])
      });
    }
  